import { useContext } from 'react';

import { MixpanelFlagsBridge } from '~/domains/feature-flags/components/MixpanelFlagsBridge';

import { UserContext } from './UserProvider';

function FeatureFlagProvider({ children }: { children: React.ReactNode }) {
  const { user } = useContext(UserContext);

  return (
    <>
      <MixpanelFlagsBridge userId={user?.id} email={user?.email} />
      {children}
    </>
  );
}

export default FeatureFlagProvider;
